// import AddCustomer from "../components/DriftComponents/CustomreManagement/AddCustomer";
// import CustomreManagement from "../components/DriftComponents/CustomreManagement/CustomreManagement";
// import EditCustomer from "../components/DriftComponents/CustomreManagement/EditCustomer";
// import Color from "../components/DriftComponents/Productsmanagment/Color";
// import Series from "../components/DriftComponents/Productsmanagment/Series";
// import SeriesDetails from "../components/DriftComponents/Productsmanagment/SeriesDetails";
// import UserProfilePage from "../pages/DriftPages/UserProfilePage";
// import MoldsManagment from "../components/moldsManagement/MoldsManagement";
// import AddMolds from "../components/moldsManagement/AddMolds";
// import EditMolds from "../components/moldsManagement/EditMolds";
// import Order from "../components/DriftComponents/OrderManagement/Order";
// import OrderBulkLoad from "../components/DriftComponents/Orders/OrderBulkLoad";
// import InventoryManagement from "../components/DriftComponents/InventoryManagement/InventoryManagement";
// import EditInventory from "../components/DriftComponents/InventoryManagement/EditInventory";
// import AddInventory from "../components/DriftComponents/InventoryManagement/AddInventory";
// import DispachOrderPage from "../pages/DriftPages/DispatchOrderPage";
// import AddDesign from "../components/DriftComponents/Productsmanagment/AddDesign";
// import EditDesign from "../components/DriftComponents/Productsmanagment/EditDesign";
// import CancelledOrderPage from "../pages/DriftPages/CancelledOrderPage";
// import DeletedOrderPage from "../pages/DriftPages/DeletedOrderPage";
// import QaTable from "../components/DriftComponents/OrderManagement/QaTable";
// import { QueueManagement } from "../components/DriftComponents/OrderManagement/QueueManagement";

// import Reports from "../components/DriftComponents/ReportsTable/Reports";
// import DriftReports from "../components/DriftComponents/ReportsTable/Reports";
// import ItemsTable from "../components/DriftComponents/OrderManagement/Items";
// import ItemsReport from "../components/DriftComponents/ReportsTable/ItemsReport";
// import NewOrders from "../components/DriftComponents/OrderManagement/NewOrder";
// import MoldReport from "../components/DriftComponents/ReportsTable/MoldsReport";
// import ViewDesigne from "../components/DriftComponents/Productsmanagment/ViewDesigne";
// import CreateProduction from "../components/ProductionUIpdate/CreateProduction";
// import DeletedBatches from "../components/ProductionUIpdate/DeletedBatches";
// import MachineManagment from "../components/ProductionUIpdate/MachineManagment";
// import ProductionReportPage from "../components/DriftComponents/ReportsTable/ProductionReportPage";
// import ProductionDetails from "../components/DriftComponents/ProductionDetails";
// import Shade from "../components/ProductionUIpdate/Shademanagment";
// import Notes from "../components/Notes/Notes";
// import AddNotes from "../components/Notes/AddNotes";
// import EditNotes from "../components/Notes/EditNotes";
 
// import AddLane from "../components/DriftComponents/RackManagement/AddLane";
// import EditLane from "../components/DriftComponents/RackManagement/EditLane";
// import LaneList from "../components/DriftComponents/RackManagement/LaneList";
// import CanvasView from "../components/DriftComponents/RackManagement/CanvasView";
// import AddShed from "../components/DriftComponents/RackManagement/shed/AddShed";
// import EditShed from "../components/DriftComponents/RackManagement/shed/EditShed";
// import ShedManagement from "../components/DriftComponents/RackManagement/shed/ShedManagement";
// import Process from "../components/DriftComponents/RackManagement/process/Process";
// import RackManagement from "../components/DriftComponents/RackManagement/RackManagement";
 

// export const allUserRoutes = [
//   // Customer Management Routes
//   {
//     path: "/customer-management",
//     element: CustomreManagement,
//     permissionKey: "customer_management",
//   },
//   {
//     path: "/customer-management/add-customer",
//     element: AddCustomer,
//     permissionKey: "customermanagement_add",
//   },
//   {
//     path: "/customer-management/edit-customer/:masterId/:id",
//     element: EditCustomer,
//     permissionKey: "customermanagement_update",
//   },

//   // Product Management Routes
//   {
//     path: "/products/color",
//     element: Color,
//     permissionKey: "product_management",
//   },
//   {
//     path: "/products/series",
//     element: Series,
//     permissionKey: "product_management",
//   },
//   {
//     path: "/products/designe",
//     element: ViewDesigne,
//     permissionKey: "product_management",
//   },
//   {
//     path: "/products/series/seriesdetails/:masterId/:seriesId",
//     element: SeriesDetails,
//     permissionKey: "pseries_update",
//   },
//   {
//     path: "/products/series/seriesdetails/add-design/:masterId/:seriesId",
//     element: AddDesign,
//     permissionKey: "pseries_update",
//   },
//   {
//     path: "/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID",
//     element: EditDesign,
//     permissionKey: "pseries_update",
//   },

//   // Inventory Management Routes
//   {
//     path: "/inventory/molds-management",
//     element: MoldsManagment,
//     permissionKey: "inventory_management",
//   },
//   {
//     path: "/inventory/molds-management/add-mold",
//     element: AddMolds,
//     permissionKey: "inventory_management",
//   },
//   {
//     path: "/inventory/molds-management/edit-mold/:moldID/:masterId",
//     element: EditMolds,
//     permissionKey: "inventory_management",
//   },

//   // order management Routes
//   {
//     path: "/ordermanagement/order",
//     element: Order,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/items",
//     element: ItemsTable,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/dispatch-order",
//     element: DispachOrderPage,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/cancelled-order",
//     element: CancelledOrderPage,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/deleted-order",
//     element: DeletedOrderPage,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/neworder",
//     element: NewOrders,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/delivery-slip",
//     element: OrderBulkLoad,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/ordermanagement/queue-table",
//     element: QaTable,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/lanes/add",
//     element: AddLane,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/lanes/edit/:id",
//     element: EditLane,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/lanes/list",
//     element: LaneList,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/lanes/canvas",
//     element: RackManagement,
//     permissionKey: "order_management",
//   },

//   {
//     path: "/rackmanagement/shed",
//     element: ShedManagement,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/rackmanagement/shed/add",
//     element: AddShed,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/rackmanagement/shed/edit/:id",
//     element: EditShed,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/rackmanagement/process",
//     element: Process,
//     permissionKey: "order_management",
//   },

//   {
//     path: "/ordermanagement/queue-management-table",
//     element: QueueManagement,
//     permissionKey: "order_management",
//   },
//   {
//     path: "/productionmanagement/BatchCalculator",
//     element: CreateProduction,
//     permissionKey: "pbatch",
//   },
//   {
//     path: "/deleted-batches",
//     element: DeletedBatches,
//     permissionKey: "pbatch",
//   },
//   {
//     path: "/productionmanagement/machine",
//     element: MachineManagment,
//     permissionKey: "pmachine",
//   },
//   {
//     path: "/productionmanagement/shade",
//     element: Shade,
//     permissionKey: "pshade",
//   },

//   // Queue Management Routes
//   // {
//   //   path: "/queuemanagement/queue",
//   //   element: QaTable,
//   //   permissionKey: "queue_management",
//   // },

//   // Inventory Management Routes
//   {
//     path: "/inventorymanagement/invetory",
//     element: InventoryManagement,
//     permissionKey: "inventory_management",
//   },
//   {
//     path: "/inventorymanagement/edit-invetory/:masterID/:inventoryId",
//     element: EditInventory,
//     permissionKey: "inventorymanagement_update",
//   },
//   {
//     path: "/inventorymanagement/add-invetory",
//     element: AddInventory,
//     permissionKey: "inventorymanagement_add",
//   },
//   {
//     path: "/reports",
//     element: DriftReports,
//     permissionKey: "report_view",
//   },
//   {
//     path: "/notes",
//     element: Notes,
//     permissionKey: "report_view",
//   },
//   {
//     path: "/notes/add",
//     element: AddNotes,
//     permissionKey: "report_view",
//   },
//   {
//     path: "/notes/edit/:id",
//     element: EditNotes,
//     permissionKey: "report_view",
//   },
//   {
//     path: "/item-reports",
//     element: ItemsReport,
//     permissionKey: "item_report",
//   },
//   {
//     path: "/mold-reports",
//     element: MoldReport,
//     permissionKey: "mold_report",
//   },
//   {
//     path: "/ProductionReportPage",
//     element: ProductionReportPage,
//     permissionKey: "production_report",
//   },
//   {
//     path: "/production-details",
//     element: ProductionDetails,
//     permissionKey: "production_report",
//   },
// ];








import { lazy } from "react";
import OrderModuleNew from "../components/DriftComponents/OrderManagement/OrderModuleNew";
// import { QueueManagement } from "../components/DriftComponents/OrderManagement/QueueManagement";
// Lazy load all components
const AddCustomer = lazy(() => import("../components/DriftComponents/CustomreManagement/AddCustomer"));
const CustomreManagement = lazy(() => import("../components/DriftComponents/CustomreManagement/CustomreManagement"));
const EditCustomer = lazy(() => import("../components/DriftComponents/CustomreManagement/EditCustomer"));
const Color = lazy(() => import("../components/DriftComponents/Productsmanagment/Color"));
const Series = lazy(() => import("../components/DriftComponents/Productsmanagment/Series"));
const SeriesDetails = lazy(() => import("../components/DriftComponents/Productsmanagment/SeriesDetails"));
const UserProfilePage = lazy(() => import("../pages/DriftPages/UserProfilePage"));
const MoldsManagment = lazy(() => import("../components/moldsManagement/MoldsManagement"));
const AddMolds = lazy(() => import("../components/moldsManagement/AddMolds"));
const EditMolds = lazy(() => import("../components/moldsManagement/EditMolds"));
const Order = lazy(() => import("../components/DriftComponents/OrderManagement/Order"));
const OrderBulkLoad = lazy(() => import("../components/DriftComponents/Orders/OrderBulkLoad"));
const InventoryManagement = lazy(() => import("../components/DriftComponents/InventoryManagement/InventoryManagement"));
const EditInventory = lazy(() => import("../components/DriftComponents/InventoryManagement/EditInventory"));
const AddInventory = lazy(() => import("../components/DriftComponents/InventoryManagement/AddInventory"));
const DispachOrderPage = lazy(() => import("../pages/DriftPages/DispatchOrderPage"));
const AddDesign = lazy(() => import("../components/DriftComponents/Productsmanagment/AddDesign"));
const EditDesign = lazy(() => import("../components/DriftComponents/Productsmanagment/EditDesign"));
const CancelledOrderPage = lazy(() => import("../pages/DriftPages/CancelledOrderPage"));
const DeletedOrderPage = lazy(() => import("../pages/DriftPages/DeletedOrderPage"));
const QaTable = lazy(() => import("../components/DriftComponents/OrderManagement/QaTable"));
const QueueManagement  = lazy(() => import("../components/DriftComponents/OrderManagement/QueueManagement"));

const Reports = lazy(() => import("../components/DriftComponents/ReportsTable/Reports"));
const DriftReports = lazy(() => import("../components/DriftComponents/ReportsTable/Reports"));
const ItemsTable = lazy(() => import("../components/DriftComponents/OrderManagement/Items"));
const ItemsReport = lazy(() => import("../components/DriftComponents/ReportsTable/ItemsReport"));
const NewOrders = lazy(() => import("../components/DriftComponents/OrderManagement/NewOrder"));
const MoldReport = lazy(() => import("../components/DriftComponents/ReportsTable/MoldsReport"));
const ViewDesigne = lazy(() => import("../components/DriftComponents/Productsmanagment/ViewDesigne"));
const CreateProduction = lazy(() => import("../components/ProductionUIpdate/CreateProduction"));
const DeletedBatches = lazy(() => import("../components/ProductionUIpdate/DeletedBatches"));
const MachineManagment = lazy(() => import("../components/ProductionUIpdate/MachineManagment"));
const ProductionReportPage = lazy(() => import("../components/DriftComponents/ReportsTable/ProductionReportPage"));
const ProductionDetails = lazy(() => import("../components/DriftComponents/ProductionDetails"));
const Shade = lazy(() => import("../components/ProductionUIpdate/Shademanagment"));
const Notes = lazy(() => import("../components/Notes/Notes"));
const AddNotes = lazy(() => import("../components/Notes/AddNotes"));
const EditNotes = lazy(() => import("../components/Notes/EditNotes"));

const AddLane = lazy(() => import("../components/DriftComponents/RackManagement/AddLane"));
const EditLane = lazy(() => import("../components/DriftComponents/RackManagement/EditLane"));
const LaneList = lazy(() => import("../components/DriftComponents/RackManagement/LaneList"));
const CanvasView = lazy(() => import("../components/DriftComponents/RackManagement/CanvasView"));
const AddShed = lazy(() => import("../components/DriftComponents/RackManagement/shed/AddShed"));
const EditShed = lazy(() => import("../components/DriftComponents/RackManagement/shed/EditShed"));
const ShedManagement = lazy(() => import("../components/DriftComponents/RackManagement/shed/ShedManagement"));
const Process = lazy(() => import("../components/DriftComponents/RackManagement/process/Process"));
const OrderStatus = lazy(() => import("../components/DriftComponents/RackManagement/orderstatus/OrderStatus"));
const RackManagement = lazy(() => import("../components/DriftComponents/RackManagement/RackManagement"));

export const allUserRoutes = [
  // Customer Management Routes
  {
    path: "/customer-management",
    element: CustomreManagement,
    permissionKey: "customer_management",
  },
  {
    path: "/customer-management/add-customer",
    element: AddCustomer,
    permissionKey: "customermanagement_add",
  },
  {
    path: "/customer-management/edit-customer/:masterId/:id",
    element: EditCustomer,
    permissionKey: "customermanagement_update",
  },

  // Product Management Routes
  {
    path: "/products/color",
    element: Color,
    permissionKey: "product_management",
  },
  {
    path: "/products/series",
    element: Series,
    permissionKey: "product_management",
  },
  {
    path: "/products/designe",
    element: ViewDesigne,
    permissionKey: "product_management",
  },
  {
    path: "/products/series/seriesdetails/:masterId/:seriesId",
    element: SeriesDetails,
    permissionKey: "pseries_update",
  },
  {
    path: "/products/series/seriesdetails/add-design/:masterId/:seriesId",
    element: AddDesign,
    permissionKey: "pseries_update",
  },
  {
    path: "/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID",
    element: EditDesign,
    permissionKey: "pseries_update",
  },

  // Inventory Management Routes
  {
    path: "/inventory/molds-management",
    element: MoldsManagment,
    permissionKey: "inventory_management",
  },
  {
    path: "/inventory/molds-management/add-mold",
    element: AddMolds,
    permissionKey: "inventory_management",
  },
  {
    path: "/inventory/molds-management/edit-mold/:moldID/:masterId",
    element: EditMolds,
    permissionKey: "inventory_management",
  },

  // order management Routes
  {
    path: "/ordermanagement/order",
    element: OrderModuleNew,
    // element: Order,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/items",
    element: ItemsTable,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/dispatch-order",
    element: DispachOrderPage,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/cancelled-order",
    element: CancelledOrderPage,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/deleted-order",
    element: DeletedOrderPage,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/neworder",
    element: NewOrders,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/delivery-slip",
    element: OrderBulkLoad,
    permissionKey: "order_management",
  },
  {
    path: "/ordermanagement/queue-table",
    element: QaTable,
    permissionKey: "order_management",
    

  },
  {
    path: "/lanes/add",
    element: AddLane,
    permissionKey: "order_management",
    useRackProvider: true,

  },
  {
    path: "/lanes/edit/:id",
    element: EditLane,
    permissionKey: "order_management",
    useRackProvider: true,

  },
  {
    path: "/lanes/list",
    element: LaneList,
    permissionKey: "order_management",
    useRackProvider: true,

  },
  {
    path: "/lanes/canvas",
    element: RackManagement,
    permissionKey: "order_management",
    useRackProvider: true,

  },

  {
    path: "/rackmanagement/shed",
    element: ShedManagement,
    permissionKey: "order_management",
  },
  {
    path: "/rackmanagement/shed/add",
    element: AddShed,
    permissionKey: "order_management",
  },
  {
    path: "/rackmanagement/shed/edit/:id",
    element: EditShed,
    permissionKey: "order_management",
  },
  {
    path: "/rackmanagement/process",
    element: Process,
    permissionKey: "order_management",
  },
  {
    path: "/rackmanagement/orderstatus",
    element: OrderStatus,
    permissionKey: "order_management",
  },

  {
    path: "/ordermanagement/queue-management-table",
    element: QueueManagement,
    permissionKey: "order_management",
  },
  {
    path: "/productionmanagement/BatchCalculator",
    element: CreateProduction,
    permissionKey: "pbatch",
  },
  {
    path: "/deleted-batches",
    element: DeletedBatches,
    permissionKey: "pbatch",
  },
  {
    path: "/productionmanagement/machine",
    element: MachineManagment,
    permissionKey: "pmachine",
  },
  {
    path: "/productionmanagement/shade",
    element: Shade,
    permissionKey: "pshade",
  },

  // Inventory Management Routes
  {
    path: "/inventorymanagement/invetory",
    element: InventoryManagement,
    permissionKey: "inventory_management",
  },
  {
    path: "/inventorymanagement/edit-invetory/:masterID/:inventoryId",
    element: EditInventory,
    permissionKey: "inventorymanagement_update",
  },
  {
    path: "/inventorymanagement/add-invetory",
    element: AddInventory,
    permissionKey: "inventorymanagement_add",
  },
  {
    path: "/reports",
    element: DriftReports,
    permissionKey: "report_view",
  },
  {
    path: "/notes",
    element: Notes,
    permissionKey: "report_view",
  },
  {
    path: "/notes/add",
    element: AddNotes,
    permissionKey: "report_view",
  },
  {
    path: "/notes/edit/:id",
    element: EditNotes,
    permissionKey: "report_view",
  },
  {
    path: "/item-reports",
    element: ItemsReport,
    permissionKey: "item_report",
  },
  {
    path: "/mold-reports",
    element: MoldReport,
    permissionKey: "mold_report",
  },
  {
    path: "/ProductionReportPage",
    element: ProductionReportPage,
    permissionKey: "production_report",
  },
  {
    path: "/production-details",
    element: ProductionDetails,
    permissionKey: "production_report",
  },
];